import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, } from "@mui/material";
import { useLocalStorage } from "@ssf/components";
import { createContext, useCallback, useContext, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { clubWebUrl as generateClubWebUrl } from "../lib/index.js";
import { TeamParticipationCard } from "./TeamParticipationCard.js";
const ClubWebLinkContext = createContext({
    setLink: () => { },
    clubWebUrl: "",
    dontShowClubWebLink: false,
});
export const ClubWebLinkProvider = ({ clubWebUrl, isS4, children, }) => {
    const { t } = useTranslation("ClubWebLinkProvider");
    const [link, setLink] = useState();
    const [dontShowClubWebLink, setDontShowClubWebLink] = useLocalStorage("ssf.dontShowClubWebLink", false);
    return (_jsxs(ClubWebLinkContext.Provider, { value: { setLink, clubWebUrl, dontShowClubWebLink }, children: [children, _jsxs(Dialog, { open: Boolean(link), onClose: () => setLink(undefined), children: [_jsx(DialogTitle, { children: t("title") }), _jsxs(DialogContent, { children: [Trans({
                                t,
                                i18nKey: "description",
                                tOptions: { postProcess: "markdown" },
                            }), _jsx(TeamParticipationCard, { isS4: isS4 })] }), _jsxs(DialogActions, { children: [_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: dontShowClubWebLink, onChange: ({ currentTarget }) => setDontShowClubWebLink(currentTarget.checked) }), label: t("dontShowAgain"), sx: { ml: 0.5, mr: "auto" } }), _jsx(Button, { color: "inherit", onClick: () => setLink(undefined), children: t("close") }), _jsx(Button, { component: "a", href: link, children: t("continue") })] })] })] }));
};
export const useClubWebLink = (path = "", params) => {
    const { setLink, clubWebUrl, dontShowClubWebLink } = useContext(ClubWebLinkContext);
    const href = clubWebUrl + generateClubWebUrl(path, params);
    const onClick = useCallback((event) => {
        if (!dontShowClubWebLink) {
            event.preventDefault();
            setLink(href);
        }
    }, [href, dontShowClubWebLink]);
    return {
        href,
        onClick,
    };
};
//# sourceMappingURL=ClubWebLinkProvider.js.map